Confirm = require 'views/lib/confirm'
Dates = require 'lib/dates'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
moment = require 'moment'
l = require 'lib/localize'

module.exports = class TokenView extends View
  className: 'member-applications-list-item'

  events:
    'click .js-revoke': 'revoke'

  render: ->
    { dateExpires, permissions, identifier, dateCreated } = @options

    data =
      identifier: identifier
      dateApproved: moment(Dates.parse(dateCreated)).calendar()
      dateExpires: if dateExpires then moment(Dates.parse(dateExpires)).calendar() else null
      neverExpires: !dateExpires?

    data.permissions = if _.isEmpty(permissions)
      [l('token perms.none')]
    else
      permissions.map (permission) ->
        scope = if permission.write then 'readwrite' else 'read'
        scale = if permission.idModel == "*" then 'general' else 'specific'
        target = permission.modelType.toLowerCase()
        l(['token perms', scope, scale, target])

    @$el.html(templates.fill('member_application', data))
    @

  revoke: (e) ->
    Util.stop(e)
    Confirm.toggle 'revoke token',
      elem: e.currentTarget
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.set "tokens", _.filter @model.get('tokens'), (token) => token.id != @options.id
        @model.pull "tokens", @options.id, =>
          track("Member", "Applications", "Revoke App")



// WEBPACK FOOTER //
// ./app/scripts/views/member/token-view.coffee